import e from"styled-components";const i=e.div`
	position: fixed;
	display: grid;
	place-content: center;
	bottom: 24px;
	inset-inline: 0;
	pointer-events: none;
	z-index: 100;
`,o=e.div`
	display: flex;
	align-items: center;
	gap: 16px;
	z-index: 10;
	border-radius: 12px;
	border: 1px solid ${({theme:e})=>e.border.black10};
	background: ${({theme:e})=>e.bg.general};
	box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.08);
	height: 64px;
	padding: 12px 16px;
	box-sizing: border-box;
	pointer-events: all;
	position: relative;
`;export{i as ToolbarContainer,o as ToolbarContent};
